<template>
    <div>
        <header class="mobile-header">
            <div class="menu-toggle">
                <a href="/amm1/#" id="menu-toggle-button" @click="displayMenu = !displayMenu"> <i class="fas fa-bars"></i> </a>
            </div>
            <div class="logo">
                <img class="apjii-logo" src="/amm1/asset/images/apjii-logo.png" alt="">
                <img class="opm-logo" src="/amm1/asset/images/idnic.png" alt="">
            </div>
        </header>
        
        <div class="container">
            <header class="desktop-header" style="justify-content: center !important; ">
                <div class="opm-logo">
                    <img src="/amm1/asset/images/apjii-logo.png" alt="">
                    <img src="/amm1/asset/images/idnic.png" alt="">
                </div>

            </header>
        </div>
        
        <div class="container">
            <div class="menu" :style="{
                display: displayMenu ? 'block' : 'none',
            }">
                <ul>
                    <li class="head-menu"><span> <a href="/amm1/">  Home </a>  </span></li>
                    <li class="head-menu"> <span> <a :href="`${backendUrl}/main`"> Registrasi</a></span>
                        <li class="head-menu"> <span> <a href="/amm1/terms"> Syarat & Ketentuan </a> </span></li>
                    </li>
                    <li class="head-menu"> <span> <a href="/amm1/program"> Program </a> </span>
                    </li>
                    <li class="head-menu"> <span> <a href="/amm1/#"> Peserta </a> </span>
                        <ul class="menu-list" id="event-list-menu-participants">
                            <li v-for="(event, index) in events" :key="index">
                                <a :href="`/amm1/participants/${event.id}`"> {{event.name}} </a>
                            </li>
                        </ul>
                    </li>
                    <li class="head-menu"> <span> <a href="/amm1/#event-location"> Lokasi </a> </span> </li>
                </ul>
            </div>
        </div>

        <main class="content">
            <slot />
        </main>

        <footer>
            <div class="container">
                <div class="logo">
                    <img src="/amm1/asset/images/apjii-logo-white.png" alt="">
                </div>
                <div class="description">
                    <p> &copy; 2018 APJII </p>
                    <p> <a href="/amm1/#"> Privacy Statement </a> | <a href="/amm1/#"> Terms and Conditions </a> | <a href="/amm1/#"> Code of Conduct </a> </p>
                    <p> <a href="/amm1/mailto:secratariat@apjii.com" > sekretariat@apjii.or.id </a> </p>
                    <div class="social-container">
                        <a href="/amm1/#"> <i class="fab fa-instagram"></i> </a>
                        <a href="/amm1/#"> <i class="fab fa-twitter"></i> </a>
                        <a href="/amm1/#"> <i class="fab fa-facebook"></i> </a>
                    </div>
                </div>
            </div>
        </footer>
    </div>    
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            backendUrl: process.env.VUE_APP_BACKEND_URL,
            events: [],
            displayMenu: true,
        }
    },
    methods: {
        fetchEvents() {
            axios.get(`${this.backendUrl}/api/series/amm1`)
                .then((res) => {
                    const id = res.data.data.id;
                    axios.get(`${this.backendUrl}/api/series/${id}/events`)
                        .then((res) => {
                            this.events = res.data.data;
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                })
                .catch((err) => {

                });
            
        }
    },
    mounted() {
        this.fetchEvents();
    }
}
</script>


